import { render, staticRenderFns } from "./GroupedList.vue?vue&type=template&id=3c8caa2e&"
import script from "./GroupedList.vue?vue&type=script&lang=js&"
export * from "./GroupedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports